import React from 'react';
/**
 * This is all to deal with code splitting and css
 * import order. Because we don't have commons chunk,
 * some thing can end up duplicated inside the chunk. This
 * is especially the case for things shared between multiple
 * chunks and not the main bundle.
 *
 * This is included in DaApp so you should not need it.
 */ const InnerNoop = ()=>{
    return null;
};
const HoistCss = ()=>{
    return /*#__PURE__*/ React.createElement(InnerNoop, null);
};
HoistCss.displayName = 'HoistCss';
export default HoistCss;

//# sourceMappingURL=HoistCss.js.map